import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import AddOplataModal from "./AddOplataModal";

const Dashboard = () => {
  const [trainers, setTrainers] = useState([]);
  const [trainings, setTrainings] = useState([]);
  const [usersWithFewEntries, setUsersWithFewEntries] = useState([]);
  const [usersWithPaymentReminders, setUsersWithPaymentReminders] = useState(
    []
  );
  const [usersWithBirthdayReminders, setUsersWithBirthdayReminders] = useState(
    []
  );
  const [selectedTrainer, setSelectedTrainer] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [menuOpen, setMenuOpen] = useState(false);
  const [showLastEntries, setShowLastEntries] = useState(false);
  const [showPaymentReminders, setShowPaymentReminders] = useState(false);
  const [showBirthdayReminders, setShowBirthdayReminders] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [users, setUsers] = useState([]);
  const [firstVisits, setFirstVisits] = useState([]);
  const [activeKarnety, setActiveKarnety] = useState([]);
  const [userSearchQuery, setUserSearchQuery] = useState("");
  const [showUserList, setShowUserList] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showSmsForm, setShowSmsForm] = useState(false);
  const token = localStorage.getItem("token"); // Pobierz token z localStorage

  const [smsContent, setSmsContent] = useState("");
  const [bookingStats, setBookingStats] = useState({
    adminBookings: 0,
    userBookings: 0,
    total: 0,
  });
  const [inactiveUsers, setInactiveUsers] = useState([]);
  const [inactiveUsersLoading, setInactiveUsersLoading] = useState(false);
  const [isOplataModalOpen, setIsOplataModalOpen] = useState(false);
  const [selectedKarnetForPayment, setSelectedKarnetForPayment] = useState(null);
  const [cache, setCache] = useState({});
  const [inactiveUsersCache, setInactiveUsersCache] = useState(null);
  const [lastInactiveUsersFetch, setLastInactiveUsersFetch] = useState(null);
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [
        trainersResponse,
        trainingsResponse,
        karnetyResponse,
        usersResponse,
        firstVisitsResponse,
      ] = await Promise.all([
        axios.get(`${BACKEND_URL}/api/trenerzy/getTrenerzy`, {headers: {
          Authorization: `Bearer ${token}`
        }}),
        axios.get(`${BACKEND_URL}/api/treningi/getTreningi`,{headers: {
          Authorization: `Bearer ${token}`
        }}),
        axios.get(`${BACKEND_URL}/api/karnet/getAllKarnety`,{headers: {
          Authorization: `Bearer ${token}`
        }}),
        axios.get(`${BACKEND_URL}/api/user/getAllUsers`,{headers: {
          Authorization: `Bearer ${token}`
        }}),
        axios.get(`${BACKEND_URL}/api/treningi/getFirstVisits`,{headers: {
          Authorization: `Bearer ${token}`
        }}),
      ]);

      setTrainers(trainersResponse.data);
      setTrainings(trainingsResponse.data.filter((t) => t.status === "completed"));
      setActiveKarnety(karnetyResponse.data);
      setUsers(usersResponse.data);
      setFirstVisits(firstVisitsResponse.data);

      setCache((prev) => ({
        ...prev,
        trainers: trainersResponse.data,
        trainings: trainingsResponse.data,
        karnety: karnetyResponse.data,
        users: usersResponse.data,
        firstVisits: firstVisitsResponse.data,
      }));

      // Calculate booking statistics
      const monthTrainings = trainingsResponse.data.filter(
        (training) =>
          new Date(training.godzina_start).getMonth() === selectedMonth &&
          new Date(training.godzina_start).getFullYear() === selectedYear &&
          training.status !== "anulowany"
      );

      setBookingStats({
        adminBookings: monthTrainings.filter((t) => t.bookedBy === "admin").length,
        userBookings: monthTrainings.filter((t) => t.bookedBy === "user").length,
        total: monthTrainings.length,
      });
    } catch (error) {
      setError("Error fetching data: " + error.message);
    } finally {
      setLoading(false);
    }
  }, [selectedMonth, selectedYear]);

  useEffect(() => {
    // Only fetch data if cache is missing or month/year changed
    if (!cache.trainers || !cache.trainings || !cache.karnety) {
      fetchData();
    } else {
      // Only update booking stats when month/year changes
      const monthTrainings = cache.trainings.filter(
        (training) =>
          new Date(training.godzina_start).getMonth() === selectedMonth &&
          new Date(training.godzina_start).getFullYear() === selectedYear &&
          training.status !== "anulowany"
      );
  
      setBookingStats({
        adminBookings: monthTrainings.filter((t) => t.bookedBy === "admin").length,
        userBookings: monthTrainings.filter((t) => t.bookedBy === "user").length,
        total: monthTrainings.length,
      });
    }
  }, [selectedMonth, selectedYear, cache]);

  useEffect(() => {
    if (cache.trainers && cache.trainings && cache.karnety) {
      setInactiveUsersLoading(true);
      fetchInactiveUsers().finally(() => setInactiveUsersLoading(false));
    }
  }, [cache]);

  

  // Fetch users with few entries
  const fetchUsersWithFewEntries = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/karnet/ostatnieWejscie`, {headers: {
        Authorization: `Bearer ${token}`
      }});
      setUsersWithFewEntries(response.data);
    } catch (error) {
      setError("Error fetching users: " + error.message);
    }
  };

  // Fetch users with payment reminders
  const fetchUsersWithPaymentReminders = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/payment/getPaymentReminders`, {headers: {
        Authorization: `Bearer ${token}`
      }});

      setUsersWithPaymentReminders(response.data);
    } catch (error) {
      setError("Error fetching users with payment reminders: " + error.message);
    }
  };

  // Fetch users with birthday reminders
  const fetchUsersWithBirthdayReminders = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/user/urodziny`, {headers: {
        Authorization: `Bearer ${token}`
      }});
      setUsersWithBirthdayReminders(response.data);
    } catch (error) {
      setError("Error fetching users with birthday reminders: " + error.message);
    }
  };

  // Fetch inactive users with caching
  const fetchInactiveUsers = async () => {
    try {
      // Check if we have cached data that's less than 10 minutes old
      const now = new Date();
      if (
        inactiveUsersCache && 
        lastInactiveUsersFetch && 
        (now - lastInactiveUsersFetch) < 10 * 60 * 1000
      ) {
        setInactiveUsers(inactiveUsersCache);
        return;
      }
      
      const response = await axios.get(`${BACKEND_URL}/api/treningi/getInactiveUsers`, {headers: {
        Authorization: `Bearer ${token}`
      }});
      setInactiveUsers(response.data);
      
      // Cache the results
      setInactiveUsersCache(response.data);
      setLastInactiveUsersFetch(now);
    } catch (error) {
      setError("Error fetching inactive users: " + error.message);
    }
  };

  useEffect(() => {
    if (showLastEntries) {
      fetchUsersWithFewEntries();
    }
  }, [showLastEntries]);

  useEffect(() => {
    if (showBirthdayReminders) {
      fetchUsersWithBirthdayReminders();
    }
  }, [showBirthdayReminders]);

  // Get training counts grouped by type for a specific trainer
  const getTrainingCounts = (trainerId) => {
    const trainerTrainings = trainings.filter(
      (training) =>
        training.trener_id._id === trainerId &&
        new Date(training.godzina_start).getMonth() === selectedMonth &&
        new Date(training.godzina_start).getFullYear() === selectedYear
    );
    const counts = {};
    trainerTrainings.forEach((training) => {
      const type = training.typ_treningu;
      counts[type] = (counts[type] || 0) + 1;
    });
    return counts;
  };

  const getTotalTrainingCounts = () => {
    const monthTrainings = trainings.filter(
      (training) =>
        new Date(training.godzina_start).getMonth() === selectedMonth &&
        new Date(training.godzina_start).getFullYear() === selectedYear
    );
    const counts = {};
    monthTrainings.forEach((training) => {
      const type = training.typ_treningu;
      counts[type] = (counts[type] || 0) + 1;
    });
    return counts;
  };

  // Function to count first visits for selected month
  const getFirstVisitsCountForMonth = () => {
    return firstVisits.filter((visit) => {
      const visitDate = new Date(visit.data);
      return (
        visitDate.getMonth() === selectedMonth &&
        visitDate.getFullYear() === selectedYear
      );
    }).length;
  };

  const getActiveKarnetyCount = () => {
    const counts = {};
    const startOfMonth = new Date(selectedYear, selectedMonth, 1);
    const endOfMonth = new Date(selectedYear, selectedMonth + 1, 0);

    activeKarnety
      .filter((karnet) => {
        const rozpoczecia = new Date(karnet.data_rozpoczecia);
        const zakonczenia = new Date(karnet.data_zakonczenia);

        return (
          karnet.aktywny &&
          rozpoczecia <= endOfMonth &&
          zakonczenia >= startOfMonth
        );
      })
      .forEach((karnet) => {
        counts[karnet.rodzaj] = (counts[karnet.rodzaj] || 0) + 1;
      });
    return counts;
  };

  const getUserTrainingDetails = (userId) => {
    const userTrainings = trainings.filter(
      (training) =>
        training.uzytkownicy._id === userId &&
        new Date(training.godzina_start).getMonth() === selectedMonth &&
        new Date(training.godzina_start).getFullYear() === selectedYear
    );

    const trainingsByTrainer = {};
    userTrainings.forEach((training) => {
      const trainerId = training.trener_id._id;
      const trainerName = `${training.trener_id.imie} ${training.trener_id.nazwisko}`;

      if (!trainingsByTrainer[trainerId]) {
        trainingsByTrainer[trainerId] = {
          trainerName,
          types: {},
        };
      }

      const type = training.typ_treningu;
      trainingsByTrainer[trainerId].types[type] =
        (trainingsByTrainer[trainerId].types[type] || 0) + 1;
    });

    return trainingsByTrainer;
  };

  const months = [
    "Styczeń",
    "Luty",
    "Marzec",
    "Kwiecień",
    "Maj",
    "Czerwiec",
    "Lipiec",
    "Sierpień",
    "Wrzesień",
    "Październik",
    "Listopad",
    "Grudzień",
  ];

  const years = Array.from(
    { length: 5 },
    (_, i) => new Date().getFullYear() - i
  );

  const filteredUsers = users.filter((user) =>
    `${user.imie} ${user.nazwisko}`
      .toLowerCase()
      .includes(userSearchQuery.toLowerCase())
  );

  const handleSendSms = async (user) => {
    try {

      if (!user.telefon) {
        alert("Ten użytkownik nie ma przypisanego numeru telefonu!");
        return;
      }

      const response = await axios.post(`${BACKEND_URL}/api/user/send-sms`, {
        phone: user.telefon,
        message: smsContent,
      });

      

      if (response.status === 200) {
        alert("SMS został wysłany pomyślnie!");
        setSmsContent("");
        setShowSmsForm(false);
      }
    } catch (error) {
      console.error("Błąd podczas wysyłania SMS:", error);
      alert(
        error.response?.data?.message ||
          "Nie udało się wysłać SMS. Spróbuj ponownie."
      );
    }
  };

  const getSuspendedKarnetyCount = () => {
    const counts = {};

    activeKarnety
      .filter((karnet) => karnet.suspended)
      .forEach((karnet) => {
        counts[karnet.rodzaj] = (counts[karnet.rodzaj] || 0) + 1;
      });
    return counts;
  };

  const handleOpenPaymentModal = (karnet) => {
    setSelectedKarnetForPayment(karnet);
    setIsOplataModalOpen(true);
  };

  const handleAddOplata = async (updatedKarnet, paymentData) => {
    try {
      await axios.put(
        `${BACKEND_URL}/api/karnet/updateKarnet/${updatedKarnet._id}`,
        updatedKarnet,
        {headers: {
          Authorization: `Bearer ${token}`
        }}
      );

      await axios.post(`${BACKEND_URL}/api/payment/addPayment`, paymentData, {headers: {
        Authorization: `Bearer ${token}`
      }});
      await axios.delete(
        `${BACKEND_URL}/api/payment/deletePaymentReminder/${updatedKarnet._id}`,
        {headers: {
          Authorization: `Bearer ${token}`
        }}
      );

      const response = await axios.get(`${BACKEND_URL}/api/karnet/getAllKarnety`, {headers: {
        Authorization: `Bearer ${token}`
      }});
      setActiveKarnety(response.data);

      alert("Płatność została dodana pomyślnie!");
    } catch (err) {
      console.error("Error adding payment:", err);
      alert("Nie udało się dodać płatności. Spróbuj ponownie.");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-800 text-center mb-8">
          Panel Administracyjny
        </h1>

        {error && (
          <div className="mb-6 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
            {error}
          </div>
        )}

        {loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
          </div>
        ) : (
          <div className="space-y-8">
            {/* Date Selection Card */}
            <div className="bg-white rounded-xl shadow-md p-6">
              <h2 className="text-xl font-semibold text-gray-700 mb-4">
                Wybierz okres
              </h2>
              <div className="flex gap-4">
                <select
                  className="flex-1 p-2 border rounded-lg bg-gray-50 hover:bg-gray-100 transition"
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(Number(e.target.value))}
                >
                  {months.map((month, index) => (
                    <option key={index} value={index}>
                      {month}
                    </option>
                  ))}
                </select>
                <select
                  className="flex-1 p-2 border rounded-lg bg-gray-50 hover:bg-gray-100 transition"
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(Number(e.target.value))}
                >
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {/* Notifications Section */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pb-10">
              {/* Last Entries Card */}
              <div className="bg-white rounded-xl shadow-md p-6">
                <h2 className="text-xl font-semibold text-gray-700 mb-4 flex items-center">
                  <span className="mr-2">🎫</span>
                  Ostatnie Wejścia
                </h2>
                <button
                  onClick={() => {
                    setShowLastEntries(!showLastEntries);
                    fetchUsersWithFewEntries();
                  }}
                  className="mb-4 w-full px-4 py-2 bg-indigo-500 text-white rounded-lg hover:bg-indigo-600 transition"
                >
                  {showLastEntries ? "Ukryj" : "Pokaż"} Wejścia
                </button>
                {showLastEntries && (
                  <div className="max-h-96 overflow-y-auto">
                    {Array.isArray(usersWithFewEntries) &&
                    usersWithFewEntries.length > 0 ? (
                      usersWithFewEntries.map((user) => (
                        <div
                          key={user.userId}
                          className="p-3 bg-gray-50 rounded-lg mb-2"
                        >
                          <p className="font-semibold">{user.userName}</p>
                          <p className="text-sm text-gray-600">
                            {user.nazwa} - Do końca karnetu {user.ilosc_wejsc}{" "}
                            wejścia
                          </p>
                        </div>
                      ))
                    ) : (
                      <div className="p-4 text-center text-gray-500 bg-gray-50 rounded-lg">
                        Brak użytkowników z małą ilością wejść
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Payment Reminders Card */}
              <div className="bg-white rounded-xl shadow-md p-6">
                <h2 className="text-xl font-semibold text-gray-700 mb-4 flex items-center">
                  <span className="mr-2">💰</span>
                  Przypomnienia o Płatności
                </h2>
                <button
                  onClick={() => {
                    setShowPaymentReminders(!showPaymentReminders);
                    fetchUsersWithPaymentReminders();
                  }}
                  className="mb-4 w-full px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition"
                >
                  {showPaymentReminders ? "Ukryj" : "Pokaż"} Przypomnienia
                </button>
                {showPaymentReminders && (
                  <div className="max-h-96 overflow-y-auto">
                    {usersWithPaymentReminders &&
                    usersWithPaymentReminders.length > 0 ? (
                      usersWithPaymentReminders.map((user) => (
                        <div
                          key={user.userId}
                          className="p-3 bg-gray-50 rounded-lg mb-2"
                        >
                          <p className="font-semibold">{user.userName}</p>

                          <div
                            key={user.karnetId._id}
                            className="text-sm text-gray-600"
                          >
                            <p>
                              Karnet: {user.karnetId.nazwa}
                              {user.karnetId.cena_za_rate && (
                                <p className="text-sm text-gray-500">
                                  Rata cena: {user.karnetId.cena_za_rate} zł
                                </p>
                              )}
                            </p>
                            <button
                              onClick={() =>
                                handleOpenPaymentModal(user.karnetId)
                              }
                              className="mt-2 px-2 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
                            >
                              Szybka Płatność
                            </button>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="p-4 text-center text-gray-500 bg-gray-50 rounded-lg">
                        Brak użytkowników z przypomnieniami o płatności
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Birthday Reminders Card */}
              <div className="bg-white rounded-xl shadow-md p-6">
                <h2 className="text-xl font-semibold text-gray-700 mb-4 flex items-center">
                  <span className="mr-2">🎂</span>
                  Przypomnienia o Urodzinach
                </h2>
                <button
                  onClick={() => {
                    setShowBirthdayReminders(!showBirthdayReminders);
                    fetchUsersWithBirthdayReminders();
                  }}
                  className="mb-4 w-full px-4 py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600 transition"
                >
                  {showBirthdayReminders ? "Ukryj" : "Pokaż"} Urodziny
                </button>
                {showBirthdayReminders && (
                  <div className="max-h-96 overflow-y-auto">
                    {usersWithBirthdayReminders.map((user) => (
                      <div
                        key={user.userId}
                        className="p-3 bg-gray-50 rounded-lg mb-2"
                      >
                        <p className="font-semibold">{user.userName}</p>
                        <p className="text-sm text-gray-600">
                          Urodziny:{" "}
                          {new Date(user.urodziny).toLocaleDateString()}
                        </p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            {/* Add this new card for inactive users */}
            <div className="bg-white rounded-xl shadow-md p-6 mb-6">
              <h2 className="text-xl font-semibold text-gray-700 mb-4">
                Nieaktywni Użytkownicy
              </h2>
              {inactiveUsersLoading ? (
                <div className="flex justify-center items-center h-64">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                </div>
              ) : (
                <div className="max-h-96 overflow-y-auto">
                  {inactiveUsers.length > 0 ? (
                    inactiveUsers.map((user) => (
                      <div
                        key={user._id}
                        className="p-3 bg-gray-50 rounded-lg mb-2"
                      >
                        <p className="font-semibold">
                          {user.imie} {user.nazwisko}
                        </p>
                        <p className="text-sm text-gray-600">
                          Ostatni trening:{" "}
                          {user.lastTrainingDate
                            ? new Date(user.lastTrainingDate).toLocaleDateString()
                            : "Brak danych"}
                        </p>
                        <p className="text-sm text-gray-600">
                          Numer Telefonu: {user.telefon}
                        </p>
                        <p className="text-sm text-gray-600">
                          Email: {user.email}
                        </p>
                      </div>
                    ))
                  ) : (
                    <div className="p-4 text-center text-gray-500 bg-gray-50 rounded-lg">
                      Brak nieaktywnych użytkowników
                    </div>
                  )}
                </div>
              )}
            </div>
            {/* Add this new card before the Trainers Grid */}
            <div className="bg-white rounded-xl shadow-md p-6 mb-6">
              <h2 className="text-xl font-semibold text-gray-700 mb-4">
                Podsumowanie Treningów ({months[selectedMonth]} {selectedYear})
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {Object.entries(getTotalTrainingCounts()).map(([type, count]) => (
                  <div
                    key={type}
                    className="flex justify-between items-center p-4 bg-gray-50 rounded-lg"
                  >
                    <span className="font-semibold">{type}</span>
                    <span className="bg-blue-500 text-white px-3 py-1 rounded-full">
                      {count}
                    </span>
                  </div>
                ))}
              </div>
            </div>
            {/* Add this new card */}
            <div className="bg-white rounded-xl shadow-md p-6 mb-6">
              <h2 className="text-xl font-semibold text-gray-700 mb-4">
                Statystyki ({months[selectedMonth]} {selectedYear})
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex justify-between items-center p-4 bg-gray-50 rounded-lg">
                  <span className="font-semibold">
                    Pierwsze Wizyty w Miesiącu
                  </span>
                  <span className="bg-green-500 text-white px-3 py-1 rounded-full">
                    {getFirstVisitsCountForMonth()}
                  </span>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl shadow-md p-6 mb-6">
              <h2 className="text-xl font-semibold text-gray-700 mb-4">
                Aktywne Karnety ({months[selectedMonth]} {selectedYear})
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {Object.entries(getActiveKarnetyCount()).map(([type, count]) => (
                  <div
                    key={type}
                    className="flex justify-between items-center p-4 bg-gray-50 rounded-lg"
                  >
                    <span className="font-semibold">{type}</span>
                    <span className="bg-green-500 text-white px-3 py-1 rounded-full">
                      {count}
                    </span>
                  </div>
                ))}
              </div>
            </div>
            <div className="bg-white rounded-xl shadow-md p-6 mb-6">
              <h2 className="text-xl font-semibold text-gray-700 mb-4">
                Zawieszone Karnety
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {Object.entries(getSuspendedKarnetyCount()).map(([type, count]) => (
                  <div
                    key={type}
                    className="flex justify-between items-center p-4 bg-gray-50 rounded-lg"
                  >
                    <span className="font-semibold">{type}</span>
                    <span className="bg-yellow-500 text-white px-3 py-1 rounded-full">
                      {count}
                    </span>
                  </div>
                ))}
                {Object.keys(getSuspendedKarnetyCount()).length === 0 && (
                  <div className="col-span-full text-center p-4 bg-gray-50 rounded-lg text-gray-500">
                    Brak zawieszonych karnetów
                  </div>
                )}
              </div>
            </div>
            {/* Add this new card before the Notifications Section */}
            <div className="bg-white rounded-xl shadow-md p-6 mb-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold text-gray-700">
                  Lista Użytkowników
                </h2>
                <div className="flex gap-4">
                  <input
                    type="text"
                    placeholder="Szukaj użytkownika..."
                    value={userSearchQuery}
                    onChange={(e) => setUserSearchQuery(e.target.value)}
                    className="border border-gray-300 rounded-lg p-2 w-64"
                  />
                  <button
                    onClick={() => setShowUserList(!showUserList)}
                    className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
                  >
                    {showUserList ? "Ukryj" : "Pokaż"} Listę
                  </button>
                </div>
              </div>

              {showUserList && (
                <div className="max-h-96 overflow-y-auto ">
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {filteredUsers.map((user) => (
                      <div
                        key={user._id}
                        className="p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition cursor-pointer"
                        onClick={() => setSelectedUser(user)}
                      >
                        <p className="font-semibold">
                          {user.imie} {user.nazwisko}
                        </p>
                        <p className="text-sm text-gray-600 mt-1">
                          Czy Ankieta wypełniona:{" "}
                          <span
                            className={
                              user.formCompleted
                                ? "text-green-600 font-medium"
                                : "text-red-600 font-medium"
                            }
                          >
                            {user.formCompleted ? "Tak" : "Nie"}
                          </span>
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
            {/* Trainers Grid */}
            <div className="bg-white rounded-xl shadow-md p-6 mb-6">
              <h2 className="text-xl font-semibold text-gray-700 mb-4">
                Lista Trenerów
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {trainers.map((trainer) => (
                  <div
                    key={trainer._id}
                    className="bg-gray-50 p-4 rounded-lg border border-gray-200 hover:shadow-lg transition duration-300"
                  >
                    <div className="flex items-center space-x-4">
                      <div className="h-12 w-12 bg-blue-500 rounded-full flex items-center justify-center">
                        <span className="text-white text-lg font-bold">
                          {trainer.imie[0]}
                        </span>
                      </div>
                      <div>
                        <h3 className="text-lg font-semibold">
                          {trainer.imie} {trainer.nazwisko}
                        </h3>
                        <p className="text-sm text-gray-500">
                          ID: {trainer._id}
                        </p>
                      </div>
                    </div>
                    <button
                      className="mt-4 w-full px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
                      onClick={() => setSelectedTrainer(trainer)}
                    >
                      Szczegóły
                    </button>
                  </div>
                ))}
              </div>
            </div>

            {/* Trainer Details Modal */}
            {selectedTrainer && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
                <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-md">
                  <h2 className="text-2xl font-bold mb-4">
                    Statystyki: {selectedTrainer.imie}{" "}
                    {selectedTrainer.nazwisko}
                  </h2>
                  <div className="space-y-4">
                    {Object.entries(getTrainingCounts(selectedTrainer._id)).map(
                      ([type, count]) => (
                        <div
                          key={type}
                          className="flex justify-between items-center p-3 bg-gray-50 rounded-lg"
                        >
                          <span className="font-semibold">{type}</span>
                          <span className="bg-blue-500 text-white px-3 py-1 rounded-full">
                            {count}
                          </span>
                        </div>
                      )
                    )}
                  </div>
                  <button
                    className="mt-6 w-full px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition"
                    onClick={() => setSelectedTrainer(null)}
                  >
                    Zamknij
                  </button>
                </div>
              </div>
            )}

            {/* User Details Modal */}
            {selectedUser && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
                <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-2xl">
                  <h2 className="text-2xl font-bold mb-4">
                    Statystyki: {selectedUser.imie} {selectedUser.nazwisko}
                  </h2>
                  <h3 className="text-lg font-semibold mb-3">
                    Treningi ({months[selectedMonth]} {selectedYear})
                  </h3>
                  <div className="space-y-4">
                    {Object.entries(
                      getUserTrainingDetails(selectedUser._id)
                    ).map(([trainerId, data]) => (
                      <div
                        key={trainerId}
                        className="bg-gray-50 p-4 rounded-lg"
                      >
                        <h4 className="font-semibold mb-2">
                          {data.trainerName}
                        </h4>
                        <div className="grid grid-cols-2 gap-2">
                          {Object.entries(data.types).map(([type, count]) => (
                            <div
                              key={type}
                              className="flex justify-between items-center p-2 bg-white rounded"
                            >
                              <span>{type}</span>
                              <span className="bg-blue-500 text-white px-3 py-1 rounded-full">
                                {count}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="mt-6 border-t pt-4">
                    <button
                      onClick={() => setShowSmsForm(!showSmsForm)}
                      className="mb-4 px-4 py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600 transition"
                    >
                      {showSmsForm ? "Ukryj formularz SMS" : "Wyślij SMS"}
                    </button>
                    {/* SMS Form Modal */}
                    {showSmsForm && (
                      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
                        <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-md">
                          <h2 className="text-2xl font-bold mb-4">
                            Wyślij SMS do {selectedUser.imie}{" "}
                            {selectedUser.nazwisko}
                          </h2>
                          <div className="space-y-4">
                            <div>
                              <label className="block text-sm font-medium text-gray-700 mb-1">
                                Numer telefonu
                              </label>
                              <input
                                type="text"
                                value={
                                  selectedUser.telefon || "Brak numeru telefonu"
                                }
                                disabled
                                className="w-full p-2 border rounded-lg bg-gray-50"
                              />
                            </div>
                            <div>
                              <label className="block text-sm font-medium text-gray-700 mb-1">
                                Treść SMS
                              </label>
                              <textarea
                                value={smsContent}
                                onChange={(e) => setSmsContent(e.target.value)}
                                className="w-full p-2 border rounded-lg h-32"
                                placeholder="Wprowadź treść wiadomości SMS"
                                maxLength={160}
                              />
                              <p className="text-sm text-gray-500 mt-1">
                                Pozostało znaków: {160 - smsContent.length}
                              </p>
                            </div>
                            <button
                              onClick={() => handleSendSms(selectedUser)}
                              className="w-full px-4 py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600 transition"
                              disabled={!selectedUser.telefon}
                            >
                              {selectedUser.telefon
                                ? "Wyślij SMS"
                                : "Brak numeru telefonu"}
                            </button>
                            <button
                              onClick={() => setShowSmsForm(!showSmsForm)}
                              className="mb-4 px-4 py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600 transition"
                            >
                              "Ukryj formularz SMS"
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <button
                    className="mt-6 w-full px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition"
                    onClick={() => setSelectedUser(null)}
                  >
                    Zamknij
                  </button>
                </div>
              </div>
            )}
            {/* Add this new card */}
            <div className="bg-white rounded-xl shadow-md p-6  pt-10">
              <h2 className="text-xl font-semibold text-gray-700 mb-4">
                Statystyki Rezerwacji ({months[selectedMonth]} {selectedYear})
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                <div className="p-4 bg-gray-50 rounded-lg">
                  <h3 className="font-semibold mb-2">
                    Rezerwacje przez Recepcję
                  </h3>
                  <div className="flex justify-between items-center">
                    <span>{bookingStats.adminBookings}</span>
                    <span className="text-blue-600">
                      {bookingStats.total
                        ? `${Math.round(
                            (bookingStats.adminBookings / bookingStats.total) *
                              100
                          )}%`
                        : "0%"}
                    </span>
                  </div>
                </div>

                <div className="p-4 bg-gray-50 rounded-lg">
                  <h3 className="font-semibold mb-2">
                    Rezerwacje przez panel użytkownika
                  </h3>
                  <div className="flex justify-between items-center">
                    <span>{bookingStats.userBookings}</span>
                    <span className="text-green-600">
                      {bookingStats.total
                        ? `${Math.round(
                            (bookingStats.userBookings / bookingStats.total) *
                              100
                          )}%`
                        : "0%"}
                    </span>
                  </div>
                </div>

                <div className="p-4 bg-gray-50 rounded-lg">
                  <h3 className="font-semibold mb-2">
                    Łączna liczba rezerwacji
                  </h3>
                  <div className="flex justify-between items-center">
                    <span>{bookingStats.total}</span>
                    <span className="text-gray-600">100%</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Modal do dodawania płatności */}
            {isOplataModalOpen && (
              <AddOplataModal
                isOpen={isOplataModalOpen}
                onClose={() => setIsOplataModalOpen(false)}
                karnet={selectedKarnetForPayment}
                onAddOplata={handleAddOplata}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
